import { getContentfulClient } from './client';
import { unwrapField } from './utils';

const CONTENT_TYPE_READING_GROUP_PAGE = 'readingGroupPage';

export async function fetchReadingGroupPage() {
  const client = getContentfulClient();
  if (!client) {
    throw new Error('Contentful is not configured');
  }

  const response = await client.getEntries({
    content_type: CONTENT_TYPE_READING_GROUP_PAGE,
    limit: 1,
    order: '-sys.updatedAt',
  });

  const entry = response.items?.[0];
  if (!entry) {
    throw new Error('No Reading Group page entries found in Contentful');
  }

  const f = entry.fields || {};

  const contentValue = f.content;
  const contentDocument =
    contentValue?.nodeType === 'document'
      ? contentValue
      : unwrapField(contentValue);

  return {
    id: entry.sys?.id,
    title: unwrapField(f.title) || '',
    contentDocument: contentDocument || null,
  };
}
